exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#master-header[data-v-11d5d577]{height:100px;z-index:9}.header-img[data-v-11d5d577]{height:65%}img[data-v-11d5d577]{height:100%;width:auto}span[data-v-11d5d577]{color:#aaa;display:block;text-align:center;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11d5d577","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/master-header.vue
// module id = 185
// module chunks = 0